<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <el-form ref="editForm" :model="changePass" :rules="rules" label-width="180px" class="editForm1">
                    <el-form-item label="旧密码：" prop="oldPass">
                        <el-input type="password" v-model="changePass.oldPass"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：" prop="newPass">
                        <el-input type="password" v-model="changePass.newPass"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="conPass">
                        <el-input type="password" v-model="changePass.conPass"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import md5 from 'js-md5';
import {changePass} from '@/api/login'

export default {
    name: 'changePassword',
    data() {
        return {
            changePass: {
                oldPass: '',
                newPass: '',
                conPass: ''
            },
            rules: {
                oldPass: [
                    {required: true, message: '旧密码不能为空', trigger: 'blur'}
                ],
                newPass: [
                    {required: true, message: '新密码不能为空', trigger: 'blur'},
                    { min: 6, max: 20, message: '新密码长度不能小于6位', trigger: 'blur' }
                ],
                conPass: [
                    {required: true, message: '确认密码不能为空', trigger: 'blur'},
                    { min: 6, max: 20, message: '新密码长度不能小于6位', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        onSubmit(){
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    if(this.changePass.newPass != this.changePass.conPass){
                        this.$msg("两次密码输入不一致")
                        return
                    }
                    let oldPass = md5(this.changePass.oldPass).toUpperCase()
                    let newPass = md5(this.changePass.newPass).toUpperCase()
                    changePass(oldPass, newPass).then(res=>{
                        if(res.code ==1){
                            sessionStorage.removeItem("U_TOKEN")
                            this.$msgs("密码修改成功")
                            setTimeout(() => {
                                this.$router.push({name:'Login'})
                            }, 500);
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                } else {
                    return false;
                }
            });
        }
    }
}
</script>